import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { getIconComponent } from '../../utils/sidebarUtils'
 
import { SidebarMenu } from 'types/sidebar';
import { cn } from 'utils';
 
interface Props extends SidebarMenu {
  selected?: boolean;
}
 
const SidebarElement = ({ title, iconName, path, selected = false }: Props) => {
  const { t } = useTranslation();
  const icon = getIconComponent(iconName);
 
  return (
    <li
      className={cn('h-8 w-full cursor-pointer rounded px-2', {
        'bg-bg-transparent_gray [&_path]:stroke-text-primary [&_span]:text-text-primary': selected
      })}
    >
      <Link
        to={path}
        className={cn(
          'flex h-full w-full flex-row items-center gap-2',
          '[&_path]:stroke-text-secondary ',
          '[&>svg]:h-4 [&>svg]:w-4'
        )}
      >
        {icon}
        <span className="text-body2 font-regular text-text-secondary">{t(title)}</span>
      </Link>
    </li>
  );
};
 
export default SidebarElement;